<script>
  import { Credits, Related, Share } from '@st-graphics/graphics-components'

  let {
    credits = undefined,
    related = undefined,
    share = undefined,
    id = undefined,
    class: className = '',
    meta = undefined,
    title = '',
  } = $props()
</script>

<footer {id} class={`article-foot ${className}`}>
  <Share {...share} {meta} {title} />

  <Credits {...credits} />

  {#if related.articles || related.blur || related.custom || related.heading}
    <Related {...related} />
  {/if}
</footer>
